import styled from 'styled-components'

export const Select = styled.select`
  display: block;
  border-color: #9e9e9e;
  cursor: pointer;
`

export const Label = styled.label`
  font-size: 13px;
  color: #707070;
`

export const Error = styled.p`
  font-size: 13px;
  color: orangered;
`
